module.exports = __webpack_public_path__ + "img/cactus.8f868e09.webp";